import { Box, Paper, Typography, Grid, Card, CardHeader, Avatar, IconButton, } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import { baseUrl } from "../../../services";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import HSEventsAndRankingView from "./HSEventsAndRankingView";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  avatar: {
    background: '#1d428a',
    height: theme.spacing(10),
    width: theme.spacing(10),
  },
  CardHeader: {
    alignItems: 'flex-start',
  },
  twitterIcon: { color: '#1da1f3', },
  instaIcon: { color: '#1d428a', },
  socialText: {
    display: "flex",
    columnGap: "8px",
    cursor: "pointer"
  },
  height100: {
    height: '100%',
  },
  playerCombineInfo: {
    color: "#c8102e",
  },
  playerCombineValues: {
    color: "#000",
  },
  inputTitle: {
    padding: "10px",
    fontSize: "1rem !important",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "500!important",
    color: "#1d428a",
  },
  gridHeader: {
    color: "#c8102e",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  gridData: {
    fontSize: "0.875rem",
    fontWeight: 500,
    paddingTop: "8px",
  },
  gridIndent: {
    [theme.breakpoints.up("lg")]: {
      margin: "15px 20px 10px 35px",
    },
    [theme.breakpoints.down("lg")]: {
      margin: "0px 0px 10px 5px",
    },
  },
}));

export default function PlayerRanking(props) {
  const { gridPropsData, agentDetails } = props;

  const classes = useStyles();
  const [gridData, setGridData] = useState([]);
  const [agentGridData, setAgentGridData] = useState([]);

  const participationType = {
    202209: "Combine Invite",
    202221: "Elite Camp Invite",
    202222: "G League Ignite",
  };

  useEffect(() => {
    let data = { ...gridPropsData };
    setGridData(data);
    let agentData = [...agentDetails];
    setAgentGridData(agentData);
  }, [gridPropsData, agentDetails]);

  return (
    <Box pt={2}>
      {/* <Paper
        elevation={5}
        sx={{
          marginTop: "10px",
         width: "calc(100vw - 285px)",
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      > */}



      <HSEventsAndRankingView
        eventId={props.eventId}
        playerID={props.playerId}
        highSchoolEventsData={
          props.playerData.highSchoolEvents ? props.playerData.highSchoolEvents : []
        }
        rankingsData={props.playerData.ranking ? props.playerData.ranking : []}
        styles={props.styles}
        playerData={props.playerData}
        viewProfile={true}
      />



      {/* </Paper> */}
    </Box>
  );
}
